import { useFdrSetActiveWishlistMutation } from 'fdr/schemas/mutation/wishlist/fdr-set-active-wishlist.generated';
import { FdrGetActiveWishlistDocument } from 'fdr/schemas/query/wishlist/fdr-get-active-wishlist.generated';
import { FdrWishlistOverviewDocument } from 'fdr/schemas/query/wishlist/fdr-wishlist-overview.generated';

const useSetActiveWishlist = () => {
  const [mutation, { loading }] = useFdrSetActiveWishlistMutation({
    refetchQueries: [FdrWishlistOverviewDocument, FdrGetActiveWishlistDocument],
  });

  async function setActiveWishlist(id: string) {
    return await mutation({
      variables: {
        wishlistId: id,
      },
    });
  }

  return {
    setActiveWishlist,
    loading,
  };
};

export default useSetActiveWishlist;
